module.exports = __webpack_public_path__ + "img/banner3.641fc3ca.png";